import { usePath } from 'common/hooks';

export const useUploadPath = (): string => {
  return usePath(`/upload`);
};
